export default __webpack_public_path__ + "assets/12a26c9d21acb9d87c11f4120932356e.jpeg";